// extracted by mini-css-extract-plugin
export var cardIcon = "_a7-4";
export var checkboxCard = "_a7-0";
export var checkboxCardSelected = "_a7-1";
export var disabled = "_a7-2";
export var outerBorder = "_a7-3";
export var spacerMedium = "_a7-7";
export var spacerSmall = "_a7-6";
export var spacerXsmall = "_a7-5";